import React, { useRef, useState, useEffect, useCallback } from "react";
import RightArrow from "../../common/icons/right-arrow";
import { useTranslation } from "react-i18next";
import "./email.scss";
import Select from "react-select";
import RichTextEditor from "./TextComp";
import { Link, useLocation } from "react-router-dom";
import { _Api, graphqlPost } from "../../api/_call";
import { store } from "../../../source/index";
import { loading, Updateloading } from "../../common/helpers/toastify";
import WeeklyTimeSelector from "./WeeklyTimeSelector";
import moment from "moment";
import CustomTimePicker from "./CustomTimePicker";

const EmailTemplate = () => {
  const dataFetched = useRef();
  const { t } = useTranslation();
  const { state } = useLocation();
  const [availableTags, setAvailableTags] = useState([]);
  const [tagsOption, setTagsOption] = useState([]);
  const [LocationarrayList, setLocationarrayList] = useState([]);
  const [completeDataObject, setCompliteDataObject] = useState();
  const [fromEmail, setFromEmail] = useState("");
  const [orgUsers, setOrgUsers] = useState([]);
  const [editorValue, setEditorValue] = useState();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const weekDays = [
    { lable: "Sunday", value: "sun" },
    { lable: "Monday", value: "mon" },
    { lable: "Tuesday", value: "tue" },
    { lable: "Wednesday", value: "wed" },
    { lable: "Thursday", value: "thu" },
    { lable: "Friday", value: "fri" },
    { lable: "Saturday", value: "sat" },
  ];

  const onChangeValueUpdate = (keyName, value) => {
    setCompliteDataObject((prevState) => ({
      ...prevState,
      [keyName]: value,
    }));
  };
  const getLocationList = async () => {
    try {
      const postdata = `{
          locations {
              id
              name 
          }
      }`;
      let responce = await graphqlPost(postdata);
      let locationarray = [];

      if (responce.data?.locations) {
        responce.data?.locations?.forEach((result) => {
          locationarray.push({
            value: result?.id,
            label: result?.name,
          });
        });
      }

      setLocationarrayList(locationarray);
    } catch (err) {
      console.log(err, "err");
    }
  };
  const gettypes = async (shortcode) => {
    try {
      let postdata = {};
      let res = await _Api(postdata, `api/v1/App/emailtemplate/get-types`);
      if (res.code === 200) {
        let tages = [];
        if (res?.data?.length) {
          res?.data.forEach((result, key) => {
            tages.push({
              label: result?.name,
              value: result?.shortcode,
              _id: result?._id,
            });
            if (state?.id) {
              if (shortcode === result?.shortcode) {
                setCompliteDataObject((prevState) => ({
                  ...prevState,
                  availabletags: {
                    label: result?.name,
                    value: result?.shortcode,
                    _id: result?._id,
                  },
                }));
              }
            }
          });
        }
        setTagsOption(tages);
        dataFetched.current = false;
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const gettypeid = async () => {
    try {
      let postdata = {
        _id: completeDataObject?.availabletags?._id,
      };
      let res = await _Api(postdata, `api/v1/App/emailtemplate/get-typesbyid`);
      if (res.code === 200) {
        setCompliteDataObject((prevState) => ({
          ...prevState,
          is_recipient: res?.data?.is_recipient ? res?.data?.is_recipient : 0,
          is_start_date: res?.data?.is_start_date
            ? res?.data?.is_start_date
            : 0,
        }));
        setAvailableTags(res?.data?.avaialable_tags);
        dataFetched.current = false;
      }
    } catch (err) {
      console.log(err, "err");
    }
  };

  const viewemail = useCallback(async () => {
    try {
      let postdata = {
        id: state?.id,
      };
      let res = await _Api(postdata, `api/v1/App/emailtemplate/view`);
      if (res?.code === 200) {
        setCompliteDataObject(res?.data);
        gettypes(res?.data?.shortcode);
        dataFetched.current = false;
      }
    } catch (err) {
      console.log(err, "err");
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (completeDataObject?.availabletags?._id) {
      if (dataFetched.current) return;
      dataFetched.current = true;
      gettypeid();
    }
    if (state?.id) {
      if (dataFetched.current) return;
      dataFetched.current = true;
      viewemail();
    } else {
      if (dataFetched.current) return;
      dataFetched.current = true;
      gettypes();
    }
    getLocationList();
    // eslint-disable-next-line
  }, [state?.id, completeDataObject?.availabletags?._id]);

  var date_format = store.getState();
  var OrgSettings = date_format?.app?.organisation_settings;
  const date_format_change = (date_format) => {
    var response;
    if (date_format === "DD/MM/YYYY") {
      response = "dd/MM/yyyy";
    } else if (date_format === "YYYY/MM/DD") {
      response = "yyyy/MM/dd";
    } else if (date_format === "MM/DD/YYYY") {
      response = "MM/dd/yyyy";
    } else if (date_format === "MM/YYYY/DD") {
      response = "MM/yyyy/dd";
    }
    return response;
  };

  useEffect(() => {
    const fetchSMTP = async () => {
      try {
        let res = await _Api({}, `api/v1/App/profile/get-smtp`);
        setFromEmail(res?.data?.smtp_username);
      } catch (err) {
        console.log(err);
      }
    };

    fetchSMTP();
  }, []);

  useEffect(() => {
    const fetchOrgUser = async () => {
      try {
        let res = await _Api({}, `api/v1/App/User/UserList`);
        const options = res?.data?.map((i) => ({
          value: i.email,
          label: i.email,
        }));
        setOrgUsers(options || []);
      } catch (err) {
        console.log(err);
      }
    };
    fetchOrgUser();
  }, []);

  const selectedOptions =
    (completeDataObject?.recipient_emails || []).map((email) => ({
      value: email,
      label: email,
    })) || [];

  const handleChange = (selected) => {
    const emails = selected ? selected.map((i) => i.value) : [];
    onChangeValueUpdate("recipient_emails", emails);
  };

  // const prepareRecurrencePayload = () => {
  //   let weeklyPayload = [];
  //   let monthlyPayload = {};

  //   // WEEKLY
  //   // if (
  //   //   completeDataObject?.recur_unit === "week" &&
  //   //   completeDataObject?.week_days
  //   // ) {
  //   //   weeklyPayload = Object.keys(completeDataObject.week_days)
  //   //     .filter(
  //   //       (day) =>
  //   //         completeDataObject.week_days[day].enabled &&
  //   //         completeDataObject.week_days[day].time
  //   //     )
  //   //     .map((day) => ({
  //   //       day: day,
  //   //       time: completeDataObject.week[day].time
  //   //         .replace(/[^\d:]/g, "")
  //   //         .trim(),
  //   //     }));
  //   // }
  //   if (
  //     completeDataObject?.recur_unit === "week" &&
  //     Array.isArray(completeDataObject?.week_days)
  //   ) {
  //     weeklyPayload = completeDataObject.week_days
  //       .filter((item) => item.enabled && item.time)
  //       .map((item) => ({
  //         day: item.day,
  //         time: item.time.replace(/[^\d:]/g, "").trim(),
  //       }));
  //   }

  //   // MONTHLY
  //   if (
  //     completeDataObject?.recur_unit === "month" &&
  //     completeDataObject?.month_rules?.week &&
  //     completeDataObject?.month_rules?.day &&
  //     completeDataObject?.month_rules?.time
  //   ) {
  //     monthlyPayload = {
  //       week: completeDataObject.month_rules.week,
  //       day: completeDataObject.month_rules.day,
  //       time: completeDataObject.month_rules.time.replace(/[^\d:]/g, "").trim(),
  //     };
  //   }

  //   return { week_days: weeklyPayload, month_rules: monthlyPayload };
  // };

  const to24Hour = (timeStr) => {
    if (!timeStr) return "";

    // Already 24-hour format
    if (/^\d{2}:\d{2}$/.test(timeStr)) {
      return timeStr;
    }

    // Convert from AM/PM to 24-hour
    return moment(timeStr.trim(), ["hh:mm A"]).format("HH:mm");
  };

  const prepareRecurrencePayload = () => {
    let weeklyPayload = [];
    let monthlyPayload = {};

    // ================= WEEKLY =================
    if (
      completeDataObject?.recur_unit === "week" &&
      Array.isArray(completeDataObject?.week_days)
    ) {
      weeklyPayload = completeDataObject.week_days
        .filter((item) => item.enabled && item.time)
        .map((item) => ({
          day: item.day,
          time: to24Hour(item.time),
        }));
    }

    // ================= MONTHLY =================
    if (
      completeDataObject?.recur_unit === "month" &&
      completeDataObject?.month_rules?.week &&
      completeDataObject?.month_rules?.day &&
      completeDataObject?.month_rules?.time
    ) {
      monthlyPayload = {
        week: completeDataObject.month_rules.week,
        day: completeDataObject.month_rules.day,
        time: to24Hour(completeDataObject.month_rules.time),
      };
    }

    return { week_days: weeklyPayload, month_rules: monthlyPayload };
  };

  const addemail = async () => {
    if (isSubmitting) return;
    setIsSubmitting(true);
    let locationarr = [];
    if (completeDataObject?.locations?.length) {
      locationarr = completeDataObject?.locations.map((option) => option.value);
    }
    let { week_days, month_rules } = prepareRecurrencePayload();
    let GetloadingID = loading();
    try {
      let postdata = {
        subject: completeDataObject?.subject,
        content: editorValue,
        locations: locationarr,
        shortcode: completeDataObject?.availabletags?.value,
        from_name: completeDataObject?.from_name,
        // "from_email": completeDataObject?.from_email,
        from_email: fromEmail,
        status: completeDataObject?.status,
        is_recipient: completeDataObject?.is_recipient
          ? completeDataObject?.is_recipient
          : 0,
        is_start_date: completeDataObject?.is_start_date
          ? completeDataObject?.is_start_date
          : 0,
        recipient_emails: selectedOptions?.map((i) => i.value),
        startAt: completeDataObject?.startAt ? completeDataObject?.startAt : "",
        recurrence_frequency: completeDataObject?.recurrence_frequency,
        recur_every: completeDataObject?.recurEvery,
        recur_time:
          completeDataObject?.recur_unit === "day"
            ? to24Hour(completeDataObject?.recur_time)
            : "",
        recur_unit: completeDataObject?.recur_unit,
        week_days:
          week_days.length && completeDataObject?.recur_unit === "week"
            ? week_days
            : [],
        month_rules:
          completeDataObject?.recur_unit === "month" ? month_rules : {},
      };
      let res = await _Api(postdata, `api/v1/App/emailtemplate/add`);
      if (res?.code === 200) {
        Updateloading(t, GetloadingID, res?.message);
      } else {
        Updateloading(t, GetloadingID, res.errors, "error");
      }
    } catch (err) {
      console.log(err, "err");
    } finally {
      setIsSubmitting(false);
    }
  };
  const editemail = async () => {
    if (isSubmitting) return;
    setIsSubmitting(true);
    let locationarr = [];
    if (completeDataObject?.locations?.length) {
      locationarr = completeDataObject?.locations.map((option) => option.value);
    }
    let { week_days, month_rules } = prepareRecurrencePayload();
    let GetloadingID = loading();
    try {
      let postdata = {
        subject: completeDataObject?.subject,
        content: editorValue,
        locations: locationarr,
        shortcode: completeDataObject?.availabletags?.value,
        from_name: completeDataObject?.from_name,
        // "from_email": completeDataObject?.from_email,
        from_email: fromEmail,
        status: completeDataObject?.status,
        is_recipient: completeDataObject?.is_recipient
          ? completeDataObject?.is_recipient
          : 0,
        is_start_date: completeDataObject?.is_start_date
          ? completeDataObject?.is_start_date
          : 0,
        recipient_emails: selectedOptions?.map((i) => i.value),
        startAt: completeDataObject?.startAt ? completeDataObject?.startAt : "",
        id: state?.id,
        recurrence_frequency: completeDataObject?.recurrence_frequency,
        recur_every: completeDataObject?.recur_every,
        recur_time:
          completeDataObject?.recur_unit === "day"
            ? to24Hour(completeDataObject?.recur_time)
            : "",
        recur_unit: completeDataObject?.recur_unit,
        week_days:
          week_days.length && completeDataObject?.recur_unit === "week"
            ? week_days
            : [],
        month_rules:
          completeDataObject?.recur_unit === "month" ? month_rules : {},
      };
      let res = await _Api(postdata, `api/v1/App/emailtemplate/edit`);
      if (res?.code === 200) {
        Updateloading(t, GetloadingID, res?.message);
      } else {
        Updateloading(t, GetloadingID, res.errors, "error");
      }
    } catch (err) {
      console.log(err, "err");
    } finally {
      setIsSubmitting(false);
    }
  };

  console.log(completeDataObject, "completeDataObject");

  return (
    <>
      <div className="main-content-wrapper-body setup-sticky-header">
        <div className="main-content-wrapper-body-top-bar d-flex align-items-center justify-content-between">
          <div className="main-content-wrapper-body-top-bar-left">
            <h1 className="main-content-wrapper-body-top-bar-left-heading fw-semibold mb-0">
              {" "}
              {t("Setup")} <RightArrow />
              <Link
                className="text-decoration-none"
                to="/app/admin/setup/email"
              >
                {t("Email")}
              </Link>{" "}
              <RightArrow />{" "}
              <span className="">{t("Create Email Template")}</span>
            </h1>
          </div>
          <div className="main-content-wrapper-body-top-bar-right d-flex align-items-center">
            <button
              className="com-plus-text-btn text-white text-center fw-semibold d-flex align-items-center border-0 rounded-1 ms-3"
              disabled={isSubmitting}
              onClick={() => {
                state?.id ? editemail() : addemail();
              }}
            >
              <i className="fa fa-upload me-2" aria-hidden="true"></i>
              {t("Publish To Template")}
            </button>
            <Link
              to="/app/admin/setup/email"
              className="square-btn square-btn-white btn-close focus-none text-decoration-none bg-white"
            ></Link>
          </div>
        </div>
        <div
          className=" d-flex flex-row"
          style={{ width: "100%", background: "#fff" }}
        >
          <div style={{ flex: "50%" }}>
            <div className="col-md-12">
              <div className="bg-white p-4 rounded-3">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="row">
                      <div>
                        <div className="v3-input-group">
                          <label className="v3-input-group-label">
                            {t("Available Tags")}{" "}
                          </label>
                          <Select
                            className="select-set select w-100 p-0"
                            placeholder=""
                            options={tagsOption}
                            value={completeDataObject?.availabletags}
                            onChange={(e) => {
                              onChangeValueUpdate("availabletags", e);
                            }}
                            classNamePrefix="common-select"
                            isSearchable={true}
                            getOptionLabel={(opt) => opt.label}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="v3-input-group">
                      <label className="v3-input-group-label">
                        {t("From Name")} :
                      </label>
                      <input
                        type="text"
                        className="v3-input-group-input w-100"
                        value={completeDataObject?.from_name || ""}
                        onChange={(e) =>
                          onChangeValueUpdate("from_name", e.target.value)
                        }
                      />
                    </div>
                    <div className="v3-input-group">
                      <label className="v3-input-group-label">
                        {t("From Email")} :
                      </label>
                      <input
                        type="text"
                        className="v3-input-group-input w-100"
                        // value={completeDataObject?.from_email || ''}
                        defaultValue={fromEmail}
                        // onChange={(e) => onChangeValueUpdate("from_email", e.target.value)}
                        disabled
                      />
                    </div>
                    {completeDataObject?.is_recipient ? (
                      // <div className="v3-input-group">
                      //   <label className="v3-input-group-label">{t("Recipient Emails")} :</label>
                      //   <input type="text" className="v3-input-group-input w-100"
                      //     value={completeDataObject?.recipient_emails || ''}
                      //     onChange={(e) => onChangeValueUpdate("recipient_emails", e.target.value)} />
                      // </div> : ''
                      <div className="v3-input-group">
                        <label className="v3-input-group-label">
                          Recipient Emails:
                        </label>
                        <Select
                          options={orgUsers}
                          value={selectedOptions}
                          onChange={handleChange}
                          isMulti
                          closeMenuOnSelect={false}
                          placeholder="Select or type emails..."
                        />
                      </div>
                    ) : null}
                    {/* {completeDataObject?.is_start_date ? (
                    <div className="v3-input-group">
                      <label className="v3-input-group-label">
                        {t("Date")} :
                      </label>
                      <DatePicker
                        className="placeholder-up-input-field v3-input-group-input w-100"
                        selected={completeDataObject?.startAt?.$date}
                        onChange={(e) => onChangeValueUpdate("startAt", e)}
                        name=""
                        dateFormat={date_format_change(
                          OrgSettings?.date_format
                        )}
                        placeholderText={"DD/MM/YYYY"}
                        autoComplete="off"
                      />
                    </div>
                  ) : (
                    ""
                  )} */}
                    <div className="v3-input-group">
                      <label className="v3-input-group-label">
                        {t("Subject")} :
                      </label>
                      <textarea
                        rows="3"
                        className="v3-input-group-input w-100 h-auto"
                        value={completeDataObject?.subject}
                        onChange={(e) =>
                          onChangeValueUpdate("subject", e.target.value)
                        }
                      />
                    </div>
                    <div className="v3-input-group ">
                      <label className="v3-input-group-label">
                        {t("Location")}
                      </label>
                      <Select
                        isMulti
                        options={LocationarrayList}
                        value={completeDataObject?.locations}
                        onChange={(e) => onChangeValueUpdate("locations", e)}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        placeholder="Location"
                        isSearchable="false"
                      />
                    </div>
                    <div className="v3-input-group available-tags">
                      <label className="v3-input-group-label">
                        {t("Available Tags")}
                      </label>
                      <RichTextEditor
                        availableTags={availableTags}
                        setEditorValue={setEditorValue}
                        editorValue={editorValue}
                        disabled={true}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style={{ flex: "34%" }} className="bg-white p-4 rounded-3">
            <div className="offset-md-3">
              <div className="v3-input-group">
                <label className="v3-input-group-label">{t("Status")}</label>
                <div className="form-check form-switch ps-0 d-flex align-items-center">
                  <label className="form-check-label" htmlFor="mixmatch">
                    {t("Active")}
                  </label>
                  <input
                    className="form-check-input float-none ms-2"
                    type="checkbox"
                    id="mixmatch"
                    checked={completeDataObject?.status ? true : false}
                    onChange={(e) =>
                      onChangeValueUpdate("status", e.target.checked ? 1 : 0)
                    }
                  />
                </div>
              </div>

              <div className="form-check form-switch ps-0 d-flex align-items-center">
                <label
                  className="form-check-label"
                  htmlFor="recurrence_frequency"
                >
                  {t("Recurrence Frequency")}
                </label>
                <input
                  className="form-check-input float-none ms-2"
                  type="checkbox"
                  id="recurrence_frequency"
                  checked={
                    completeDataObject?.recurrence_frequency ? true : false
                  }
                  onChange={(e) =>
                    onChangeValueUpdate(
                      "recurrence_frequency",
                      e.target.checked ? 1 : 0
                    )
                  }
                />
              </div>

              {completeDataObject?.recurrence_frequency && (
                <>
                  <div className="d-flex gap-4 align-items-center mt-3 mb-3">
                    {/* Recur Every Number */}
                    <div
                      className="d-flex flex-column gap-2"
                      style={{ flex: "40%" }}
                    >
                      <label style={{ fontSize: "14px", color: "#9E9E9E" }}>
                        {t("Recur Every")}
                      </label>
                      <input
                        type="number"
                        min={1}
                        className="form-control"
                        value={completeDataObject?.recur_every || ""}
                        onChange={(e) =>
                          onChangeValueUpdate("recur_every", e.target.value)
                        }
                      />
                    </div>

                    {/* Unit Dropdown */}
                    <div
                      className="d-flex flex-column gap-2"
                      style={{ flex: "60%" }}
                    >
                      <label style={{ fontSize: "14px", color: "#9E9E9E" }}>
                        {t("Unit")}
                      </label>
                      <select
                        className="form-select"
                        value={completeDataObject?.recur_unit || ""}
                        onChange={(e) =>
                          onChangeValueUpdate("recur_unit", e.target.value)
                        }
                      >
                        <option value="" disabled>
                          --select--
                        </option>
                        <option value="day">{t("day(s)")}</option>
                        <option value="week">{t("week(s)")}</option>
                        <option value="month">{t("month(s)")}</option>
                      </select>
                    </div>
                  </div>
                  <p style={{ fontSize: "12px", color: "#C0C0C0" }}>
                    {t(
                      "Select a unit (day/week/month). If using the options below (day/nth/weekly), enter only the fields that apply"
                    )}
                  </p>
                  <hr />
                </>
              )}

              {/* Week */}
              {completeDataObject?.recur_every &&
                completeDataObject?.recur_unit === "week" && (
                  <WeeklyTimeSelector
                    scheduleProp={completeDataObject?.week_days}
                    onScheduleChange={(scheduleArray) =>
                      onChangeValueUpdate("week_days", scheduleArray)
                    }
                  />
                )}
              {/* MONTH */}
              {completeDataObject?.recur_every &&
                completeDataObject?.recur_unit === "month" && (
                  <>
                    <div className="d-flex flex-column gap-2 mb-3">
                      <label style={{ fontSize: "14px", color: "#9E9E9E" }}>
                        {t("Monthly — Or On (nth weekday)")}
                      </label>
                      <div className="d-flex gap-4 align-items-center mt-3 mb-3">
                        <div
                          className="d-flex flex-column gap-2"
                          style={{ flex: "50%" }}
                        >
                          <select
                            className="form-select"
                            value={completeDataObject?.month_rules?.week || ""}
                            onChange={(e) =>
                              onChangeValueUpdate("month_rules", {
                                ...completeDataObject.month_rules,
                                week: e.target.value,
                              })
                            }
                          >
                            <option value="" disabled>
                              --select--
                            </option>
                            <option value="1st">{t("1st")}</option>
                            <option value="2nd">{t("2nd")}</option>
                            <option value="3rd">{t("3rd")}</option>
                            <option value="4th">{t("4th")}</option>
                            <option value="last">{t("last")}</option>
                          </select>
                        </div>

                        {/* Unit Dropdown */}
                        <div
                          className="d-flex flex-column gap-2"
                          style={{ flex: "50%" }}
                        >
                          <select
                            className="form-select"
                            value={completeDataObject?.month_rules?.day || ""}
                            onChange={(e) =>
                              onChangeValueUpdate("month_rules", {
                                ...completeDataObject.month_rules,
                                day: e.target.value,
                              })
                            }
                          >
                            <option value="" disabled>
                              --select--
                            </option>

                            {weekDays.map((i, index) => (
                              <option value={i.value} key={index}>
                                {t(i.lable)}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                    <p style={{ fontSize: "12px", color: "#C0C0C0" }}>
                      {t("Example: 2nd Wednesday")}
                    </p>
                    <hr />
                  </>
                )}
              {/* day and month week */}
              {((completeDataObject?.recur_every &&
                completeDataObject?.recur_unit === "day") ||
                (completeDataObject?.recur_unit === "month" &&
                  completeDataObject?.month_rules?.week &&
                  completeDataObject?.month_rules?.day)) && (
                <div className="d-flex flex-column gap-2">
                  <label style={{ fontSize: "14px", color: "#9E9E9E" }}>
                    {t("Weekly — On days and Time")}
                  </label>
                  {/* 
                  <input
                    type="clock"
                    className="form-control"
                    value={
                      completeDataObject?.recur_unit === "day"
                        ? completeDataObject?.recur_time
                        : completeDataObject?.month_rules?.time
                    }
                    onChange={(e) => {
                      if (completeDataObject?.recur_unit === "day") {
                        onChangeValueUpdate("recur_time", e.target.value);
                      } else {
                        onChangeValueUpdate("month_rules", {
                          ...completeDataObject.month_rules,
                          time: e.target.value,
                        });
                      }
                    }}
                    style={{ width: "30%" }}
                    placeholder="HH:MM"
                  /> */}
                  <CustomTimePicker
                    value={
                      completeDataObject?.recur_unit === "day"
                        ? completeDataObject?.recur_time
                        : completeDataObject?.month_rules?.time
                    }
                    onChange={(val) => {
                      if (completeDataObject?.recur_unit === "day") {
                        onChangeValueUpdate("recur_time", val);
                      } else {
                        onChangeValueUpdate("month_rules", {
                          ...completeDataObject.month_rules,
                          time: val,
                        });
                      }
                    }}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EmailTemplate;
